import { Colors } from '@sigma-frontend-libs/commons'

import { components, services } from '@/utils'

import formatTable from '@/components/format/table'
import preloader from '@/components/preloader'
import detailsItem from '@/components/services/sendings/outgoing/details/item'
import { sendingsStatuses } from '@/components/services/sendings/utils'
import tag from '@/components/tag'

function renderType(h, type) {
  return h(
    tag,
    {
      props: {
        color: Colors[type],
        label: type
      }
    }
  )
}
function renderStatus(h, status) {
  if (status) {
    return h(
      tag,
      {
        props: {
          icon: sendingsStatuses[status].icon,
          color: sendingsStatuses[status].color,
          label: this.getTranslate(`${services.sendings}.statuses.${status}`)
        }
      }
    )
  }
}
function renderTags(h, item) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__tabs-fallbacks-item__header`
    },
    [
      renderType.call(this, h, item.type),
      renderStatus.call(this, h, item.status)
    ]
  )
}

function renderFormatTable(h, item) {
  return h(
    formatTable,
    {
      props: {
        value: item,
        service: services.sendingsFallbacks
      }
    }
  )
}
function renderItem(h, item) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__tabs-fallbacks-item`
    },
    [
      renderTags.call(this, h, item),
      renderFormatTable.call(this, h, item)
    ]
  )
}
function renderItems(h) {
  if (Array.isArray(this.itemsWithoutId) && this.itemsWithoutId.length) {
    return h(
      'div',
      {
        class: `${services.sendings}-item__tabs-fallbacks-items`
      },
      [
        this.itemsWithoutId.map(item => {
          return renderItem.call(this, h, item)
        })
      ]
    )
  }
}

function renderPreloader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder preloader__holder--absolute pa-5'
    },
    [ h(preloader) ]
  )
}
function renderAbsolutePreloader(h) {
  if (this.loading) {
    return h(
      'div',
      {
        class: 'preloader__holder preloader__holder--absolute'
      },
      [ h(preloader) ]
    )
  }
}
function renderSending(h, item) {
  return h(
    detailsItem,
    {
      props: { value: item }
    }
  )
}
function renderSendings(h) {
  return h(
    components['expansion-panels'],
    {
      style: { position: 'relative' },
      props: {
        outline: true,
        rounded: true
      }
    },
    [
      this.items.map(item => {
        return renderSending.call(this, h, item)
      }),

      renderAbsolutePreloader.call(this, h)
    ]
  )
}
function renderSendingsBody(h) {
  if (Array.isArray(this.items) && this.items.length) {
    return renderSendings.call(this, h)
  } else {
    switch (this.loading) {
      case true: return renderPreloader.call(this, h)
      case false:
      default: {
        if (this.itemsWithoutId.length === 0) {
          return h(components.empty)
        }
      }
    }
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__tabs-fallbacks`
    },
    [
      renderItems.call(this, h),
      renderSendingsBody.call(this, h)
    ]
  )
}
